export default __webpack_public_path__ + "static/GRID2022-Stock-IDPs0-24-light-4f05cb083cd5bdee6ada10accef9bd67.jpg";